import React from 'react';
const LOGOS = [{
  name: 'Narra',
  svg: <img src="https://cdn.magicpatterns.com/uploads/wfhGfqyhPgSM9ub1eNcUs2/Group_4.svg" alt="Narra" style={{
    height: 28,
    width: 'auto',
    display: 'block'
  }} data-id="element-85" />
}, {
  name: 'Invesko',
  svg: <img src="https://cdn.magicpatterns.com/uploads/gzpUxwdPjU3oPvmSCR2wMS/Group_18.svg" alt="Invesko" style={{
    height: 28,
    width: 'auto',
    display: 'block'
  }} data-id="element-86" />
}, {
  name: 'RIFE',
  svg: <img src="https://cdn.magicpatterns.com/uploads/pNdj8CivscfqTY54NqSnGq/Group_96.svg" alt="RIFE" style={{
    height: 32,
    width: 'auto',
    display: 'block'
  }} data-id="element-87" />
}, {
  name: 'Mind What Matters',
  svg: <img src="https://cdn.magicpatterns.com/uploads/x5SPAFmdV3DPBmszavcJvt/Group_1948754876.svg" alt="Mind What Matters" style={{
    height: 36,
    width: 'auto',
    display: 'block'
  }} data-id="element-88" />
}, {
  name: 'Brand 5',
  svg: <img src="https://cdn.magicpatterns.com/uploads/fMN75D6PtyKVVy8NNViyEw/Group_1948754968.svg" alt="Brand 5" style={{
    height: 32,
    width: 'auto',
    display: 'block'
  }} data-id="element-89" />
}, {
  name: 'xchange',
  svg: <img src="https://cdn.magicpatterns.com/uploads/71Lro4NoAkxFCFdAzLk97j/Group_1948755017.svg" alt="xchange" style={{
    height: 32,
    width: 'auto',
    display: 'block'
  }} data-id="element-90" />
}, {
  name: 'kinhub',
  svg: <img src="https://cdn.magicpatterns.com/uploads/awHy4mzbEbrupQxFR7WVZ7/Group.svg" alt="kinhub" style={{
    height: 36,
    width: 'auto',
    display: 'block'
  }} data-id="element-91" />
}, {
  name: 'Become',
  svg: <img src="https://cdn.magicpatterns.com/uploads/kVT8X9YqpMLqs5nSao5PAa/image_268.svg" alt="Become" style={{
    height: 32,
    width: 'auto',
    display: 'block'
  }} data-id="element-92" />
}, {
  name: 'Humble',
  svg: <img src="https://cdn.magicpatterns.com/uploads/1PnzhdmiL9DA55f4hbSHHS/LOGOWHITE-SVG_2.svg" alt="Humble" style={{
    height: 40,
    width: 'auto',
    display: 'block',
    filter: 'brightness(0)'
  }} data-id="element-93" />
}, {
  name: 'Opus',
  svg: <img src="https://cdn.magicpatterns.com/uploads/jU8onH1hNM592RcetgLpfp/opus_logo.svg" alt="Opus" style={{
    height: 28,
    width: 'auto',
    display: 'block'
  }} data-id="element-94" />
}, {
  name: 'Firetree',
  svg: <img src="https://cdn.magicpatterns.com/uploads/iW7ZsTjF8XaurgwEoW6hNX/logo-black.jpg" alt="Firetree" style={{
    height: 32,
    width: 'auto',
    display: 'block'
  }} data-id="element-95" />
}, {
  name: 'Narra Health',
  svg: <img src="https://cdn.magicpatterns.com/uploads/jtZUQzZvVbm7GxG76gKHTs/pasted-image.svg" alt="Narra Health" style={{
    height: 28,
    width: 'auto',
    display: 'block'
  }} data-id="element-96" />
}];
const CAROUSEL_ITEMS = [...LOGOS, ...LOGOS];
export function LogoCarousel() {
  return <div className="w-full mt-16 md:mt-24" data-id="element-97">
      <p className="text-center text-xs tracking-[0.2em] uppercase mb-8" style={{
      color: 'var(--muted)',
      opacity: 0.5
    }} data-id="element-98">
        People we've worked with
      </p>

      <div className="w-full overflow-hidden py-4" data-id="element-99">
        <div className="logo-carousel" style={{
        display: 'flex',
        width: 'max-content',
        animation: 'marquee 40s linear infinite',
        willChange: 'transform'
      }} data-id="element-100">
          {CAROUSEL_ITEMS.map((logo, i) => <div key={i} className="flex items-center justify-center" style={{
          padding: '0 32px',
          opacity: 0.8,
          flexShrink: 0
        }} title={logo.name} data-id="element-101">
              {logo.svg}
            </div>)}
        </div>
      </div>
    </div>;
}